module.exports = __webpack_public_path__ + "static/img/16.9943b74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16.jpg
// module id = bTF/
// module chunks = 0